import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import planBanner from "../Images/Plans Banner1.png";
import "./Plans.css";

function Plans() {
  const plans = [
    {
      title: "Nutrition Program",
      path: "/plans/nutritionprogram",
      description: "Customized nutrition programs for your health goals.",
    },
    {
      title: "Online Consultation",
      path: "/plans/consultation",
      description: "One-on-one expert nutrition guidance online.",
    },
    {
      title: "Diet Plan",
      path: "/plans/dietplan",
      description: "Personalized diet plans based on your lifestyle.",
    },
    {
      title: "PMOS / PCOD Warriors",
      path: "/plans/pcod",
      description: "Specialized nutrition support for hormonal balance.",
    },
  ];

  return (
    <div>
        <Image src={planBanner} alt="Nutrinest Plans" className="contact-banner" />
        <section className="plans-page">
      <Container>
        
        <div className="plans-header">
          <h1>Our Plans</h1>
          <p>Choose the right wellness plan for your journey.</p>
        </div>

        <Row className="g-4">
          {plans.map((plan, index) => (
            <Col lg={6} key={index}>
              <div className="plan-card">
                
                <h3>{plan.title}</h3>
                <p>{plan.description}</p>

                <Button
                  as={Link}
                  to={plan.path}
                  className="plan-btn"
                >
                  Explore Plan
                </Button>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
    </div>
  );
}

export default Plans;